import { IconChevronsUp } from '@tabler/icons-react'
import React, { useState, useEffect } from 'react'
import "./Topscroll.css"

const Topscroll = () => {
  const [isVisible, setIsVisible] = useState(false)

  // Show/hide button based on scroll position
  const toggleVisibility = () => {
    if (window.scrollY > 300) { // Button appears after scrolling 300px
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  // Add scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <div>
      <div className="relative">
        <button
          onClick={scrollToTop}
          className={`scroll-top group fixed bottom-8 right-5 z-50 flex size-12 items-center justify-center rounded-full border-2 bg-white
            ${isVisible 
              ? 'translate-y-0 opacity-100' 
              : 'translate-y-20 opacity-0'
            } 
            border-danger text-n8 duration-300 hover:border-primary hover:text-title 
            sm:bottom-10 sm:right-10`}
        >
          <div className="flex size-9 items-center justify-center rounded-full bg-danger duration-300 group-hover:bg-primary">
            <IconChevronsUp size={24} className="text-white duration-300" />
          </div>
        </button>
      </div>
    </div>
  )
}

export default Topscroll